import {getCode} from 'iso-3166-1-alpha-2';
export const formatCountry = (country : string, isMobile : boolean) => {
    return isMobile ? getCode(country) :  country;
}